<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" width="450px" class="my-dialog-template" :close-on-click-modal="false">
      <el-form :inline="true" :model="formData" ref="formRef" class="my-form-template" label-width="100px" v-loading="loading">
        <el-form-item label="模板ID" class="full" v-if="formData.code && type != 'copy'">
          <span>{{ formData.code }}</span>
        </el-form-item>
        <el-form-item
          label="模板名称"
          prop="name"
          class="full"
          :rules="[$tools.formRule.required('请输入模板名称'), $tools.formRule.str('模板名称最长20个字', 20)]"
        >
          <el-input v-model="formData.name" placeholder="20个字以内" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="归属团队" prop="mechanId" class="full" :rules="$tools.formRule.required('请选择')">
          <merchantTree v-if="!formData.id" v-model="formData.mechanId" @change="changeOrg"></merchantTree>
          <span v-else>{{ formData.mechanName }}</span>
        </el-form-item>

        <el-form-item label="服务费类型" class="full">
          <el-radio-group v-if="!formData.id" v-model="formData.type">
            <el-radio :disabled="level == 3" label="2">业务员</el-radio>
            <el-radio :disabled="level == 3" label="1">团队</el-radio>
          </el-radio-group>
          <span v-else>{{ formData.type == 2 ? '业务员' : '团队' }}</span>
        </el-form-item>
        <el-form-item label="备注" prop="remark" class="full">
          <el-input v-model="formData.remark" placeholder="50个字以内" type="textarea" rows="4" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="save()" v-if="formData.id">确定</el-button>
        <el-button @click="save(true)" v-else>下一步</el-button>
      </div>
    </el-dialog>
    <!-- 批量配费 -->
    <batchSetting ref="batchSetting" @save="success"></batchSetting>
  </div>
</template>
<script>
import batchSetting from "./batchSetting";
import merchantTree from '@/components/merchantTree.vue'
export default {
  components: { batchSetting, merchantTree },
  data: () => ({
    visible: false,
    loading: false,
    title: "新增服务费模板",
    type: "",
    level: '',
    formData: {
      type: '1'
    },
    templateList: [],
    userInfo: {}
  }),
  mounted() {
    this.userInfo = this.$tools.getLocal('userinfo')
  },
  methods: {
    changeOrg({ level }) {
      this.level = level
      if (level == 3) {
        this.formData.type = '2'
      }
    },
    open(data = {}, type) {
      this.type = type;
      this.level = ''
      data = JSON.parse(JSON.stringify(data));
      if (type == 'copy') {
        this.title = "复制服务费模板";
        if (data.name) {
          data.name = data.name + "（1）"
        }
      } else if (data.id) {
        this.title = "编辑服务费模板信息";
      } else {
        data.type = '1'
        this.title = "新增服务费模板";
      }
      this.formData = JSON.parse(JSON.stringify(data))
      this.visible = true
      this.$refs.formRef && this.$refs.formRef.clearValidate()
    },
    success() {
      this.visible = false
      this.$emit("reload")
    },
    save(isNext) {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          if (isNext) {
            this.$refs.batchSetting.open(this.formData, 'add');
            return;
          }
          this.loading = true
          try {
            let res = {};
            if (this.type == "copy") {
              res = await this.copyAjax();
            } else {
              this.$refs.batchSetting.type = "";
              res = await this.$refs.batchSetting.save(this.formData, false);
            }
            if (res && res.httpCode == 200) {
              this.success();
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }

        }
      })
    },
    copyAjax() {
      return this.$http({
        url: "/master/commissonTemplate/copyTemplate",
        type: 'POST',
        params: this.formData,
      }).then(res => {
        this.$message.success("复制成功");
        return res
      })
    }
  },
}
</script>
<style lang='scss' scoped>
</style>